
import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ActivatedRoute, Router, RouterState } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import { AuthenticationService } from 'src/app/services/authentication.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
//#endregion
//#region Model
import { Colaborador } from 'src/app/models/colaborador';
import { Auth } from 'src/app/models/auth';
import { PedidoCadastro, PedidoCadastroItem } from 'src/app/models/pedido-cadastro';
import { CentroCusto } from 'src/app/models/centro-custo';
import { Unidade } from 'src/app/models/unidade';
import { Departamento } from 'src/app/models/departamento';
//#endregion
//#region Enum
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { environment } from '../../../../../../environments/environment';
import { INovoPedido } from 'src/app/shared/interfaces/novo-pedido.interface';
import { ModalFilterColaboradorPipe } from '../../../../../shared/pipes/modal-filter-colaborador.pipe';
import { DropDownItem } from 'src/app/shared/helpers/models/dropdown-item';
import { StatusApp } from 'src/app/shared/enums/status-app.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ColaboratorsGroupService } from 'src/app/services/group/colaborators-group.service';
import { Group, GroupProduct } from 'src/app/models/group';
import { GroupService } from 'src/app/services/group/group.service';
import { ColaboradorPedido } from 'src/app/models/colaborador-pedido';
import { Purchase, PurchaseItens, Order, OrderItens } from 'src/app/models/purchase';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { GestorService } from 'src/app/services/gestor.service';
import { FormControl } from '@angular/forms';
import { Group as GroupPurchase } from 'src/app/models/purchase';

//#endregion


@Component({
  selector: 'app-nova-compra-grupo-colaborador',
  templateUrl: './nova-compra-grupo-colaborador.component.html',
  styleUrls: ['./nova-compra-grupo-colaborador.component.css']
})
export class NovacompraGrupoColaboradorComponent implements OnInit, INovoPedido {

    //#region Filtro
    public filtroNome: string;
    public filtroCPF: string;
    public filtroMatricula: string;
    public filtroCentroCusto: string;
    public filtroUnidade: string;
    public filtroDepartamento: string;
    public filtroPesquisa: string;
    public filtroPesquisaSporadic: string;
    //#endregion

    colaboradorSelect: boolean;

    //#region Paginação
    currentPage = 1;
    currentPageModal = 1;
    showItem = '10';
    //#endregion

    public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    public colaboradores: Colaborador[];
    public colaboradoresList: Colaborador[];
    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];
    private currentUser: Auth;
    private currentPedidoValue: PedidoCadastro;
    private currentPurchaseValue: Purchase;
    public purchase: Purchase;
    public gestorId: number;
    public cedenteId: number;

    public count = 0;
    public selectAllItem: boolean;
    public totalColaboradores: number;
    public isEmpty: boolean;

    //#region filtro DropDown
    public filtroCentroCustoDropDownList = [];
    public filtroCentroCustoSelectedItems = [];
    public filtroUnidadeDropDownList = [];
    public filtroUnidadeSelectedItems = [];
    public filtroDepartamentoDropDownList = [];
    public filtroDepartamentoSelectedItems = [];

    public dropDownSettings: IDropdownSettings = {};

    public costCenterCtrl: FormControl = new FormControl();
    public unitCtrl: FormControl = new FormControl();
    public departmentCtrl: FormControl = new FormControl();
    public nameCtrl: FormControl = new FormControl();
    public cpfCtrl: FormControl = new FormControl();
    public registerCtrl: FormControl = new FormControl();

    //#endregion
    public alterado = false;
    public grupo: Group;
    public productOfGroup: GroupProduct[];


    //#region Ordenação
    sortOrder: boolean;
    //#endregion

    //#region Menu de Contexto
    overlayRef: OverlayRef | null;
    subscription: Subscription;
    @ViewChild('contextMenu', { static: true }) contextMenu: TemplateRef<any>;
    //#endregion

    @ViewChild('modalColaboradorEsporadico', { static: true }) modalColaboradorEsporadico: TemplateRef<any>;
    @ViewChild('noSelectColaborador', { static: true }) noSelectColaborador: TemplateRef<any>;
    @ViewChild('noColaborador', { static: true }) noColaborador: TemplateRef<any>;



    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public viewContainerRef: ViewContainerRef,
        private modalService: NgbModal,
        private alertService: NewAlertService,
        private authenticationService: AuthenticationService,
        private gestorService: GestorService,
        private pedidoDataService: PedidoDataService,
        private pedidoService: PedidoService,
        private centroCustoService: CentroCustoService,
        private unidadeService: UnidadeService,
        private departamentoService: DepartamentoService,
        private pipeModalFilterColaboradorPipe: ModalFilterColaboradorPipe,
        private colaboradorGrupoService: ColaboratorsGroupService,
        private grupoService: GroupService,
        private productGroupService: ProductsGroupService) {
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.currentPurchaseValue = this.pedidoDataService.currentPurchaseValue;
        this.gestorId = 0;
        this.cedenteId = 0;
        if(this.currentPurchaseValue.group != null){
            this.grupo = new Group();
            this.grupo.id = this.currentPurchaseValue.group.groupId.toString();
            this.grupo.guidID = this.currentPurchaseValue.group.groupGuid;
        }else{
            this.grupo = this.grupoService.getGrupo();
        }
        this.load();
        this.loadFiltroDropDown();



        this.purchase = new Purchase(0,'');
        this.purchase.purchaseItens = [];
        this.purchase.managerGuid = this.currentUser.token.userReferenceId;
        this.purchase.purchaseItens.forEach( e => {
            e.order.orderItens = [];
        });
    }

    public load() {
        this.gestorService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.gestorId = response.result[0].gestorId;
                this.cedenteId = response.result[0].cedenteId;
                this.getProductsOfGroup();
            });
        this.colaboradorGrupoService.getColaboradoresPedidoFromGrupo(this.currentUser.token.assignorGuid, +this.grupo.id).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {

                    this.colaboradores = response.result;
                    this.colaboradoresList = response.result;
                    if (this.colaboradoresList.length <= 0) {
                        this.showModal(this.noColaborador);
                    }

                    for (const s of this.colaboradoresList) {
                        if(s.document != null){
                            const tam = environment.TOTAL_CARACTERE_CPF - s.document.length;
                            let str = s.document.toString();
                            for (let i = 0; i < tam; i++) {
                                str = '0' + str;
                            }
                            s.document = str;
                        }
                        if (s.costCenter == null) {
                            s.costCenter = 'Nenhum';
                        }
                        if (s.unity == null) {
                            s.unity = 'Nenhum';
                        }
                        if (s.department == null) {
                            s.department = 'Nenhum';
                        }
                        s.selected = true;
                    }

                    this.totalColaboradores = this.colaboradoresList.length;
                    this.colaboradores = this.colaboradoresList;
                    if (this.currentPurchaseValue.purchaseItens) {
                        this.colaboradores.forEach(objColaborador => {
                            objColaborador.selected = false;

                            this.currentPurchaseValue.purchaseItens.forEach(objCompraItem => {
                                if (objCompraItem) {
                                    objCompraItem.order.orderItens.forEach(objPedidoItem => {
                                        if(objPedidoItem.collaboratorId == objColaborador.collaboratorId){
                                            objColaborador.selected = true;
                                        }
                                    })
                                }
                            });
                        });
                    }
                    this.updateCount();
                }
            },
            error => {
                this.alertService.error('Erro ao carregar favorecidos');
            }
        );
    }

    getProductsOfGroup() {
        this.productGroupService.getGroupsByGroup(this.grupo.guidID, this.currentPurchaseValue.assignorId).subscribe(res => {

            if (res.status === 1) {
                this.productOfGroup = [];
                this.productOfGroup = res.result;
                this.currentPurchaseValue.purchaseItens = [];
                for(let i = 0; i< this.productOfGroup.length; i++){
                    this.currentPurchaseValue.purchaseItens[i] = new PurchaseItens();
                    this.currentPurchaseValue.purchaseItens[i].order = new Order();

                    this.currentPurchaseValue.purchaseItens[i].productId = this.productOfGroup[i].productID;
                    this.currentPurchaseValue.purchaseItens[i].order.assignorContractId = this.productOfGroup[i].assignorContractId;
                    this.currentPurchaseValue.purchaseItens[i].order.productDescription = this.productOfGroup[i].productName;
                    this.currentPurchaseValue.purchaseItens[i].order.productGuid = this.productOfGroup[i].productGuid;
                    this.currentPurchaseValue.purchaseItens[i].order.productCategory = this.productOfGroup[i].productCategory;
                    this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent = this.productOfGroup[i].productFee === null ? 0 : this.productOfGroup[i].productFee;
                    this.currentPurchaseValue.purchaseItens[i].order.managerId = this.gestorId;
                    this.currentPurchaseValue.purchaseItens[i].order.orderItens = [];
                }
            }
        });
    }

    //#region Filtro DropDown
    public loadFiltroDropDown() {
        this.centroCustoService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.centrosCustosList = response.result;
                this.centrosCustosList.forEach(obj => {
                    this.filtroCentroCustoDropDownList.push(new DropDownItem(obj.centroCustoId.toString(), obj.nome));
                });
            }
        );

        this.unidadeService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.unidadesList = response.result;
                this.unidadesList.forEach(obj => {
                    this.filtroUnidadeDropDownList.push(new DropDownItem(obj.unidadeId.toString(), obj.nome));
                });
            }
        );

        this.departamentoService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.departamentosList = response.result;
                this.departamentosList.forEach(obj => {
                    this.filtroDepartamentoDropDownList.push(new DropDownItem(obj.departamentoId.toString(), obj.nome));
                });
            }
        );

        this.dropDownSettings = {
            singleSelection: false,
            idField: 'ITEM_ID',
            textField: 'ITEM_TEXT',
            selectAllText: 'Selecionar Tudo',
            unSelectAllText: 'Desmarcar Tudo',
            searchPlaceholderText: 'Buscar',
            allowSearchFilter: true,
            itemsShowLimit: 3
        };
    }

    onItemSelectFiltroCentroCusto(item: any) { }
    onSelectAllFiltroCentroCusto(items: any) { }
    onItemDeSelectFiltroCentroCusto(items: any) { }

    onItemSelectFiltroUnidade(item: any) { }
    onSelectAllFiltroUnidade(items: any) { }
    onItemDeSelectFiltroUnidade(items: any) { }

    onItemSelectFiltroDepartamento(item: any) { }
    onSelectAllFiltroDepartamento(items: any) { }
    onItemDeSelectFiltroDepartamento(items: any) { }
    //#endregion

    public savePedido() {
        for (let i = 0; i < this.productOfGroup.length; i++) {

            this.setSelected(i);
            this.pedidoDataService.setCurrentPurchaseValue(this.currentPurchaseValue);

            this.purchase.purchaseItens[i] = new PurchaseItens();
            this.purchase.purchaseItens[i].order = new Order();
            this.purchase.purchaseItens[i].order.orderItens = [];
            this.purchase.assignorId = this.cedenteId;
            this.purchase.purchaseValue = 0;
            this.purchase.managerGuid = this.currentUser.token.userReferenceId;
            this.purchase.purchaseItens[i].order.assignorContractId = this.currentPurchaseValue.purchaseItens[i].order.assignorContractId;
            this.purchase.purchaseItens[i].order.managerId = this.gestorId;
            this.purchase.purchaseItens[i].order.productDescription = this.currentPurchaseValue.purchaseItens[i].order.productDescription;
            this.purchase.purchaseItens[i].order.productGuid = this.currentPurchaseValue.purchaseItens[i].order.productGuid;

            this.purchase.purchaseItens[i].productId = this.currentPurchaseValue.purchaseItens[i].productId;
            this.purchase.purchaseItens[i].order.orderItens = [];
            for (let aux = 0; aux < this.currentPurchaseValue.purchaseItens[i].order.orderItens.length; aux++) {

                const auxOrderItem: OrderItens = new OrderItens();

                auxOrderItem.collaboratorId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].collaboratorId;
                auxOrderItem.cardId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].cardId;
                auxOrderItem.comments = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].comments;

                auxOrderItem.document = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].document;
                auxOrderItem.hasApp = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].hasApp;
                auxOrderItem.name = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].name;
                auxOrderItem.registry = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].registry;
                auxOrderItem.regularityId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].regularityId;
                auxOrderItem.regularityDescription = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].regularityDescription;
                auxOrderItem.referenceValue = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].referenceValue;
                auxOrderItem.providedValue = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].providedValue;

                this.purchase.purchaseItens[i].order.orderItens.push(auxOrderItem);
            }
        }
        this.pedidoService.createPurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {


                        this.purchase.purchaseId = response.result.purchaseId;
                        this.purchase.purchaseItens[i].order.orderId = response.result.purchaseItens[i].order.orderId;
                        this.purchase.purchaseItens[i].order.orderDescription = response.result.purchaseItens[i].order.orderDescription;
                        this.purchase.purchaseItens[i].purchaseItemId = response.result.purchaseItens[i].purchaseItemId;
                        this.purchase.purchaseItens[i].purchaseId = response.result.purchaseId;;

                        this.pedidoDataService.setCurrentPurchaseValue(this.purchase);
                    }
                    this.pedidoService.updatePurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
                        res => {
                            if (res.status === ApiError.Sucesso) {
                                this.alertService.success('Recarga salva');
                            } else {
                                this.alertService.success('Erro ao salvar a recarga');
                            }
                    });

                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error(error);
            }
        );
    }


    orderBy(collumnName: string, sortOrder: boolean) {
        this.colaboradoresList.sort(
            (a, b) => {
                const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
                const aVal = (a[collumnName] === null ? dftl : a[collumnName]).toString();
                const bVal = (b[collumnName] === null ? dftl : b[collumnName]).toString();
                let result = aVal.localeCompare(bVal, undefined, { numeric: true });
                if (sortOrder) {
                    result = bVal.localeCompare(aVal, undefined, { numeric: true });
                }
                return result;
            }
        );
    }

    applyFilter() {

        if(this.nameCtrl.value != null)
            this.filtroNome = this.nameCtrl.value;
        if(this.cpfCtrl.value != null)
            this.filtroCPF = this.cpfCtrl.value;
        if(this.registerCtrl.value != null)
            this.filtroMatricula = this.registerCtrl.value;
        if(this.costCenterCtrl.value != null)
            this.filtroCentroCustoSelectedItems = this.costCenterCtrl.value;
        if(this.unitCtrl.value != null)
            this.filtroUnidadeSelectedItems = this.unitCtrl.value;
        if(this.departmentCtrl.value != null)
            this.filtroDepartamentoSelectedItems = this.departmentCtrl.value;

        this.colaboradores = this.pipeModalFilterColaboradorPipe
            .transform(this.colaboradoresList, this.filtroPesquisa, '', this.filtroNome, this.filtroCPF,
                this.filtroMatricula, this.filtroCentroCusto, this.filtroUnidade, this.filtroDepartamento, '');

    }

    updateCount() {
        this.count = this.colaboradoresList.filter(x => x.selected).length;
    }

    selectAll(value: boolean) {

        const colaboradores = this.pipeModalFilterColaboradorPipe
            .transform(this.colaboradoresList, this.filtroPesquisa, '', this.filtroNome, this.filtroCPF,
                this.filtroMatricula, this.filtroCentroCusto, this.filtroUnidade, this.filtroDepartamento, '');
        colaboradores.forEach(obj => {
            if (this.colaboradoresList.find(x => x.colaboradorId === obj.colaboradorId)) {
                obj.selected = value;
            }
        });

        this.updateCount();
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }
    removerFilter(){
        this.filtroNome = '';
        this.filtroCPF = '';
        this.filtroMatricula = '';
        this.filtroCentroCustoSelectedItems = [];
        this.filtroUnidadeSelectedItems = [];
        this.filtroDepartamentoSelectedItems = [];
        this.colaboradores = this.pipeModalFilterColaboradorPipe
            .transform(this.colaboradoresList, this.filtroPesquisa, '', this.filtroNome, this.filtroCPF,
                this.filtroMatricula, this.filtroCentroCusto, this.filtroUnidade, this.filtroDepartamento, '');
    }

    showModal(content: any) {
        this.modalService.open(content, { centered: true, size: 'xl' });
    }


    public previous() {
        this.router.navigate(['create'], { relativeTo: this.route.parent });
    }

    public next() {
        for (let i = 0; i < this.productOfGroup.length; i++) {
            this.setSelected(i);
            this.pedidoDataService.setCurrentPurchaseValue(this.currentPurchaseValue);

            this.purchase.purchaseItens[i] = new PurchaseItens();
            this.purchase.purchaseItens[i].order = new Order();
            this.purchase.purchaseItens[i].order.orderItens = [];

            this.purchase.assignorId = this.currentPurchaseValue.assignorId;
            this.purchase.managerGuid = this.currentUser.token.userReferenceId;
            this.purchase.purchaseValue = 0;
            this.purchase.purchaseItens[i].productId = this.currentPurchaseValue.purchaseItens[i].productId;

            this.purchase.purchaseItens[i].order.assignorContractId = this.currentPurchaseValue.purchaseItens[i].order.assignorContractId;
            this.purchase.purchaseItens[i].order.managerId = this.gestorId;
            this.purchase.purchaseItens[i].order.productDescription = this.currentPurchaseValue.purchaseItens[i].order.productDescription;
            this.purchase.purchaseItens[i].order.productGuid = this.currentPurchaseValue.purchaseItens[i].order.productGuid;
            this.purchase.purchaseItens[i].order.totalFeePercent = this.productOfGroup[i].productFee != null ? this.currentPurchaseValue.purchaseItens[i].order.totalFeePercent : 0;
            this.purchase.purchaseItens[i].order.productCategory = this.currentPurchaseValue.purchaseItens[i].order.productCategory;
            this.purchase.purchaseItens[i].order.isPercent = this.productOfGroup[i].isPercent;
            this.purchase.purchaseItens[i].order.orderItens = [];

            for (let aux = 0; aux < this.currentPurchaseValue.purchaseItens[i].order.orderItens.length; aux++) {

                const auxOrderItem: OrderItens = new OrderItens();

                auxOrderItem.collaboratorId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].collaboratorId;
                auxOrderItem.cardId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].cardId;
                auxOrderItem.comments = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].comments;

                if(this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].document != null)
                    auxOrderItem.document = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].document.toString();
                else
                    auxOrderItem.document = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].document;
                auxOrderItem.hasApp = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].hasApp;
                auxOrderItem.hasCard = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].hasCard;
                auxOrderItem.name = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].name;
                auxOrderItem.registry = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].registry;
                auxOrderItem.regularityId = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].regularityId;
                auxOrderItem.regularityDescription = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].regularityDescription;
                auxOrderItem.referenceValue = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].referenceValue;
                auxOrderItem.providedValue = this.currentPurchaseValue.purchaseItens[i].order.orderItens[aux].providedValue;

                this.purchase.purchaseItens[i].order.orderItens.push(auxOrderItem);
            }
        }
        this.currentPurchaseValue.managerGuid = this.purchase.managerGuid;

        this.purchase.group = new GroupPurchase();
        this.purchase.group.groupId = +this.grupo.id;
        this.purchase.group.groupGuid = this.grupo.guidID;

        if(this.currentPurchaseValue.purchaseId === null || this.currentPurchaseValue.purchaseId === 0 || this.currentPurchaseValue.purchaseId === undefined){
            if (this.currentPurchaseValue.purchaseItens[0].order.orderItens.length > 0) {
                    this.pedidoService.createPurchase(this.currentUser.token.assignorGuid,this.purchase).subscribe(
                        response => {

                            if (response.status === ApiError.Sucesso) {
                                for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {
                                    this.purchase.purchaseItens[i].order.productIcon = response.result.purchaseItens[i].order.productIcon;
                                    this.purchase.purchaseItens[i].order.productColor = response.result.purchaseItens[i].order.productColor;
                                    this.purchase.purchaseItens[i].order.orderId = response.result.purchaseItens[i].order.orderId;
                                    this.purchase.purchaseItens[i].order.orderDescription = response.result.purchaseItens[i].order.orderDescription;
                                    for(let j = 0; j < this.currentPurchaseValue.purchaseItens[i].order.orderItens.length; j++){
                                        this.purchase.purchaseItens[i].order.orderItens[j].orderItemId = response.result.purchaseItens[i].order.orderItens[j].orderItemId;
                                        this.purchase.purchaseItens[i].order.orderItens.forEach(obj => {
                                            this.currentPurchaseValue.purchaseItens[i].order.orderId = response.result.purchaseItens[i].order.orderId;
                                            this.currentPurchaseValue.purchaseItens[i].order.orderItens[j].orderItemId = response.result.purchaseItens[i].order.orderItens[j].orderItemId;
                                        });
                                    }
                                }

                                this.purchase.purchaseId = 0;
                                this.purchase.purchaseId = response.result.purchaseId;
                                for (let i = 0; i < response.result.purchaseItens.length; i++) {
                                    this.purchase.purchaseItens[i].purchaseItemId = 0;
                                    this.purchase.purchaseItens[i].purchaseItemId = response.result.purchaseItens[i].purchaseItemId;
                                    this.purchase.purchaseItens[i].purchaseId = this.purchase.purchaseId;
                                }
                                this.pedidoDataService.setCurrentPurchaseValue(this.purchase);
                                this.router.navigate(['selecaoperiodo'], { relativeTo: this.route.parent });
                                //this.pedidoDataService.setCurrentPurchaseValue(this.currentPurchaseValue);
                            } else {
                                this.alertService.error(response.message);
                            }
                        }
                    );
                } else {
                    this.alertService.error('Você precisa selecionar ao menos um favorecido');
                }
            }else{

                if (this.currentPurchaseValue.purchaseItens[0].order.orderItens.length > 0) {
                    if(this.currentPurchaseValue.purchaseDate != null || this.currentPurchaseValue.purchaseDate != undefined){
                        this.purchase.needChangeDate = true;
                    }
                    this.purchase.purchaseId = this.currentPurchaseValue.purchaseId;
                    this.pedidoService.updatePurchase(this.currentUser.token.assignorGuid, this.purchase).subscribe(
                        res => {
                            if (res.status === ApiError.Sucesso){
                                for (let i = 0; i < this.currentPurchaseValue.purchaseItens.length; i++) {
                                    this.purchase.purchaseItens[i].order.productIcon = res.result.purchaseItens[i].order.productIcon;
                                    this.purchase.purchaseItens[i].order.productColor = res.result.purchaseItens[i].order.productColor;
                                    this.purchase.purchaseItens[i].order.orderId = res.result.purchaseItens[i].order.orderId;
                                    this.purchase.purchaseItens[i].order.orderDescription = res.result.purchaseItens[i].order.orderDescription;
                                    for(let j = 0; j < this.currentPurchaseValue.purchaseItens[i].order.orderItens.length; j++){
                                        this.purchase.purchaseItens[i].order.orderItens[j].orderItemId = res.result.purchaseItens[i].order.orderItens[j].orderItemId;
                                        this.purchase.purchaseItens[i].order.orderItens.forEach(obj => {
                                            this.currentPurchaseValue.purchaseItens[i].order.orderId = res.result.purchaseItens[i].order.orderId;
                                            this.currentPurchaseValue.purchaseItens[i].order.orderItens[j].orderItemId = res.result.purchaseItens[i].order.orderItens[j].orderItemId;
                                        });
                                    }
                                }
                                //this.purchase.purchaseId = 0;
                                this.purchase.purchaseId = res.result.purchaseId;
                                for (let i = 0; i < res.result.purchaseItens.length; i++) {
                                    this.purchase.purchaseItens[i].purchaseItemId = res.result.purchaseItens[i].purchaseItemId;
                                    this.purchase.purchaseItens[i].purchaseId = this.purchase.purchaseId;
                                }
                            }
                        });
                        this.pedidoDataService.setCurrentPurchaseValue(this.purchase);
                        this.router.navigate(['selecaoperiodo'], { relativeTo: this.route.parent });
                }
                else {
                    this.alertService.error('Você precisa selecionar ao menos um favorecido');
                }
        }

    }

    setSelected(index) {
        const orderItens = this.currentPurchaseValue.purchaseItens[index].order.orderItens;
        this.currentPurchaseValue.purchaseValue = 0;
        this.currentPurchaseValue.purchaseItens[index].order.orderItens = [];

        let contractId = this.currentPurchaseValue.purchaseItens[index].order.assignorContractId
        this.colaboradoresList.forEach(obj => {
            if (obj.selected) {
                let orderItem = null;
                if (orderItens && obj.cartao) {
                    orderItem = orderItens.find(x => x.cardId === obj.cartao.cardId);
                }
                if (orderItem) {
                    this.currentPurchaseValue.purchaseItens[index].order.orderItens.push(orderItem);
                    this.currentPurchaseValue.purchaseValue += orderItem.valor;
                } else {
                    const orderItem: OrderItens = new OrderItens();
                    if(contractId == obj.assignorContractId){
                        orderItem.collaboratorId = obj.collaboratorId;
                        orderItem.name = obj.name;
                        orderItem.document = obj.document;
                        orderItem.registry = obj.registry;
                        orderItem.hasApp = obj.hasApp;
                        orderItem.hasCard = obj.hasCard;
                        orderItem.referenceValue = obj.standardValue;
                        orderItem.regularityId = obj.standardPeriodId;
                        orderItem.regularityDescription = obj.standardPeriod;
                        orderItem.cardId = obj.cardId;
                    }else{
                        let result = obj.accounts.find( ({assignorContractId}) => assignorContractId === contractId);
                        orderItem.collaboratorId = obj.collaboratorId;
                        orderItem.name = obj.name;
                        orderItem.document = obj.document;
                        orderItem.registry = obj.registry;
                        orderItem.hasApp = obj.hasApp;
                        orderItem.hasCard = obj.hasCard;
                        orderItem.referenceValue = result === undefined ? 0 : result.standardValue;
                        orderItem.regularityId = result === undefined ? 0 : result.standardPeriodId;
                        orderItem.regularityDescription = result === undefined ? null : result.standardPeriod;
                        orderItem.cardId = result === undefined ? 0 : result.cardId;
                    }


                    this.currentPurchaseValue.purchaseItens[index].order.orderItens.push(orderItem);
                }
            }
        });
        this.updateCount();
    }

    /* updateEsporadicos() {
        this.colaboradoresList.forEach(obj => {
            if (obj.esporadico) {
                obj.selected = true;
            }
        });
        this.alterado = !this.alterado;
    }

    updateSelected() {
        this.colaboradoresList.forEach(obj => {
            if (!obj.selecionado) {
                obj.esporadico = false;
            }
        });
        this.alterado = !this.alterado;
    } */

    public newColaborador() {
        const state: RouterState = this.router.routerState;
        this.router.navigate(['portal/colaborador/create'], { queryParams: { urlReturn: state.snapshot.url } });
    }
    navigateToColaborador() {
        this.router.navigate(['portal/colaborador/']);
    }

    deletedSelect(toDeleteColaborador: Colaborador) {
        const toDeletePedidoItems = this.currentPedidoValue.pedidoItens.find(x => x.cpf === toDeleteColaborador.documento);
        if (toDeletePedidoItems) {
            this.currentPedidoValue.pedidoItens.splice(this.currentPedidoValue.pedidoItens.indexOf(toDeletePedidoItems), 1);
        }
        this.colaboradoresList.splice(this.colaboradoresList.indexOf(toDeleteColaborador), 1);
    }
}
